<template>
    <el-dialog custom-class="ck-config-dialog-class"
     :top="top"
     :title="title" 
     :visible.sync="dialogVisible" 
     @close="close" width="600px" 
     :before-close="close"
     :close-on-click-modal="false" 
     :show-close="false">
       <el-form :model="formData" :rules="rules" ref="form" size="mini" label-width="120px">
        <el-form-item label="Cookie名称" prop="ck_name">
            <el-input v-model="formData.ck_name" type="text"  placeholder="请输入Cookie名称" size="mini" class="dialog-div-input"></el-input>
        </el-form-item> 
        <el-form-item label="Cookie值" prop="ck_value">
            <el-input v-model="formData.ck_value" type="textarea" :rows="6" placeholder="请输入Cookie值" size="mini" class="dialog-div-input"></el-input>
        </el-form-item> 
        <!-- 未定义变量 -->
        <el-form-item label="状态" prop="ck_status">
            <el-radio-group v-model="formData.ck_status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
        </el-form-item> 
       </el-form>        
       <div slot="footer" class="dialog-footer">
           <el-button size="mini" @click="close">取 消</el-button>
           <el-button class="dialog-btn" type="primary" size="mini" @click="sure" :disabled="loading">确 定</el-button>
       </div>
   </el-dialog>
</template>
<script>
export default {
   name: 'CKConfig',
   props:{
       dialogVisible:{
           type: Boolean,
           default: false,
       },
       loading:{
           type: Boolean,
           default: false,
       },
       title:{
           type: String,
           default: '',
       },
       top:{
           type: String,
           default: '15vh',
       },
       form:{
           type: Object,            
           required:true,
           default:{},            
       }  

   },
      data(){        
          
       return {
           rules:{
                ck_name:[ { required: true, message: '请输入Cookie名称', trigger: 'blur' },],
                ck_value:[
                    { required: true, message: '请输入Cookie值', trigger: 'blur' },
                    //至少3个字符   
                    { min: 3, message: '长度至少3个字符', trigger: 'blur' },
                    
                ],
                ck_status:[
                    { required: true, message: '请选择状态', trigger: 'blur' },
                ],
           },
           formData:{
            ck_value:'',
            ck_status:1,
            ck_name:''
           },
       }
   },
   mounted() { 
       for (const key in this.form) {
           if(key !== 'loading'){
               this.$set(this.formData, key, this.form[key]);
           }
           
       }
   },

   methods: {        
       //重置表单
       resetForm(formName) {
           this.$refs[formName].resetFields();
       },
       close(){            
           this.resetForm('form')
           this.$emit("close");
       },
       sure(){
           this.$refs['form'].validate((valid) => {
                   if (valid) {          
                         
                       this.$emit("sure",this.formData)
                      
                   } else {
                       return false;
                   }
               });    
       }
   }

}
</script>
<style lang="scss" scoped>

</style>